import type {Citation, CitationStoredVehicleSummary} from "../types";

export function getCitationStoredVehicleId(citation: Citation): number | null {
  const id = citation.stored_vehicle_id ?? citation.stored_vehicle?.stored_vehicle_id;
  return typeof id === "number" && Number.isFinite(id) ? id : null;
}

export function getCitationStoredVehicleSummary(
  citation: Citation,
): CitationStoredVehicleSummary | null {
  if (citation.stored_vehicle) {
    return citation.stored_vehicle;
  }
  const id = getCitationStoredVehicleId(citation);
  if (id == null) {
    return null;
  }
  return {stored_vehicle_id: id, tracking_started_at: "", cite_eligible_at: ""};
}

export function citationHasStoredVehicleOrigin(citation: Citation): boolean {
  return getCitationStoredVehicleId(citation) != null;
}

export function getCitationStoredVehicleBadgeLabel(storedVehicleId: number): string {
  return `Stored vehicle #${storedVehicleId}`;
}

export function getCitationStoredVehicleTooltip(storedVehicleId: number): string {
  return `Citation issued from stored vehicle tracking #${storedVehicleId}`;
}
